// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-products-product-packaging-packaging-bijfw{background:var(--color-grayLight);border-radius:12px;font-size:14px;padding:24px}.components-products-product-packaging-title-ubizh{font-size:18px;font-weight:700;margin-bottom:16px}ul.components-products-product-packaging-ul-bfowb{padding-left:16px}li.components-products-product-packaging-li-bpadu{list-style-type:disc}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"packaging": "components-products-product-packaging-packaging-bijfw",
	"title": "components-products-product-packaging-title-ubizh",
	"ul": "components-products-product-packaging-ul-bfowb",
	"li": "components-products-product-packaging-li-bpadu"
};
module.exports = ___CSS_LOADER_EXPORT___;
